<!--
 * Created by JackCui on 2021/12/13
 -->

<script>
  export default {
    name: 'list-layout',
    props: {
      node: Object
    },
    created () {
      /**
       * 权限 > 获取从对象布局 > 释放队列
       */
    },
    render (h) {
      return (
        <render viewContent={this.node.viewContent}/>
      )
    }
  }
</script>

<style scoped>

</style>
